import Swiper from "swiper";
import { Autoplay, FreeMode, Navigation, Controller, EffectFade } from 'swiper/modules';
import AbstractComponent from "./abstract-component";

Swiper.use([FreeMode, Autoplay, Navigation, Controller, EffectFade]);

export default class Testimony extends AbstractComponent {
	constructor(el) {
		super(el);
		this.DOM = {};
		this.imagesSwiper = null;
		this.quotesSwiper = null;
		this.initDomElements();
		this.initSlider();
	}

	initDomElements() {
		this.DOM = {};
		this.DOM.imagesContainer = this.$el.querySelector('.c-testimony__track__images.swiper');
		this.DOM.quotesContainer = this.$el.querySelector('.c-testimony__track__quotes.swiper');
		this.DOM.arrowNext = this.$el.querySelector('.c-testimony__arrow.right');
		this.DOM.arrowPrev = this.$el.querySelector('.c-testimony__arrow.left');
	}

	updateArrowsState() {
		if (!this.DOM.arrowPrev || !this.DOM.arrowNext || !this.quotesSwiper) return;
		const isBeginning = this.quotesSwiper.isBeginning;
		const isEnd = this.quotesSwiper.isEnd;
		this.DOM.arrowPrev.disabled = isBeginning;
		this.DOM.arrowNext.disabled = isEnd;
	}

	bindArrows() {
		if (!this.DOM.arrowNext || !this.DOM.arrowPrev) return;
		this.DOM.arrowNext.addEventListener('click', () => {
			if (this.imagesSwiper) this.imagesSwiper.slideNext();
		});
		this.DOM.arrowPrev.addEventListener('click', () => {
			if (this.imagesSwiper) this.imagesSwiper.slidePrev();
		});
	}

	initSlider() {
		if (!this.DOM.imagesContainer || !this.DOM.quotesContainer) return;

		this.imagesSwiper = new Swiper(this.DOM.imagesContainer, {
			slidesPerView: 1,
			speed: 1000,
			allowTouchMove: false,
			freeMode: false,
			loop: false,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			autoHeight: true
		});

		this.quotesSwiper = new Swiper(this.DOM.quotesContainer, {
			slidesPerView: 1,
			speed: 1000,
			allowTouchMove: false,
			freeMode: false,
			loop: false,
			effect: 'fade',
			fadeEffect: { crossFade: true },
			autoHeight: true
		});

		// Synchronisation bidirectionnelle
		this.imagesSwiper.controller.control = this.quotesSwiper;
		this.quotesSwiper.controller.control = this.imagesSwiper;

		// Mettre à jour l'état des flèches
		this.quotesSwiper.on('afterInit', () => this.updateArrowsState());
		this.quotesSwiper.on('slideChange', () => this.updateArrowsState());
		this.imagesSwiper.on('slideChange', () => this.updateArrowsState());

		this.bindArrows();
		this.updateArrowsState();
	}

	destroy() {
		if (this.DOM.arrowNext) this.DOM.arrowNext.replaceWith(this.DOM.arrowNext.cloneNode(true));
		if (this.DOM.arrowPrev) this.DOM.arrowPrev.replaceWith(this.DOM.arrowPrev.cloneNode(true));
		if (this.imagesSwiper) this.imagesSwiper.destroy(true, true);
		if (this.quotesSwiper) this.quotesSwiper.destroy(true, true);
	}
}
